import type {
  HoldingUnitCapabilities,
  UnitProfileCategory,
  UnitProfileFixedIdPolicy,
  UnitProfileWorkflow,
} from '@crv/contracts';

export interface UnitProfileWorkflowEligibilityInput {
  profileCategory: UnitProfileCategory;
  fixedIdPolicy: UnitProfileFixedIdPolicy;
  capabilityPolicy: HoldingUnitCapabilities;
}

export function isUnitProfileWorkflowEligible(
  profile: UnitProfileWorkflowEligibilityInput,
  workflow: UnitProfileWorkflow,
): boolean {
  switch (workflow) {
    case 'fast_weigh_create':
      return profile.profileCategory === 'source' && profile.capabilityPolicy.canReceiveIntake;
    case 'fixed_id_asset_start':
      return profile.fixedIdPolicy === 'fixed_asset_required';
    case 'build_product_input':
      return profile.capabilityPolicy.canBuildProduct;
    case 'build_product_output':
    case 'inbound_receipt_product':
      return profile.profileCategory === 'product';
    case 'inbound_receipt_unit':
      return (
        profile.profileCategory === 'product' ||
        (profile.profileCategory === 'source' && profile.capabilityPolicy.canReceiveIntake)
      );
    case 'build_product_leftover':
      return profile.profileCategory === 'leftover';
    case 'transfer_source':
      return profile.capabilityPolicy.canTransferOut;
    case 'shipment_candidate':
      return profile.capabilityPolicy.canShip;
    default:
      return assertNever(workflow);
  }
}

function assertNever(value: never): never {
  throw new Error(`Unsupported unit profile workflow: ${String(value)}`);
}
